import * as Yup from 'yup'
// import { MIN_PASSWORD_LENGTH } from './const'
export default function getYupValidationSchema(values) {
    return Yup.object().shape({
        employee: Yup.array().required('employee is required!'),
        startTime: Yup.string().required('startTime is required!'),
        startDate: Yup.date().required('Date is required!'),
        endTime: Yup.string().required('endTime is required!'),
        break: Yup.number('input numbers in minutes.')
            .integer('input numbers in minutes.')
            .min(0, 'input numbers in minutes.')
            .max(1440, 'input numbers in minutes.'),
    })
}
